module.exports = __webpack_public_path__ + "img/21_111.5b1d2ec6.png";